import React from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';

const QuickActionCard = ({ 
  title, 
  description, 
  iconName, 
  onClick, 
  variant = "default",
  disabled = false,
  badge = null 
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
          variant === 'warning' ? 'bg-warning/10' :
          variant === 'success' ? 'bg-success/10' :
          variant === 'error'? 'bg-error/10' : 'bg-primary/10'
        }`}>
          <Icon 
            name={iconName} 
            size={24} 
            color={
              variant === 'warning' ? 'var(--color-warning)' :
              variant === 'success' ? 'var(--color-success)' :
              variant === 'error' ? 'var(--color-error)' :
              'var(--color-primary)'
            } 
          />
        </div>
        {badge && (
          <span className="bg-error text-error-foreground text-xs font-medium px-2 py-1 rounded-full">
            {badge}
          </span>
        )}
      </div>
      
      <h3 className="text-lg font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground mb-4">{description}</p>
      
      <Button 
        variant="outline" 
        onClick={onClick}
        disabled={disabled}
        className="w-full"
      >
        {disabled ? 'Not Available' : 'Access'}
      </Button>
    </div>
  );
};

export default QuickActionCard;